module.exports = __webpack_public_path__ + "assets/img/solar-panels-5.da99f49e.jpg";